module.exports = __webpack_public_path__ + "brand-icons.579cad8471395197d60c.eot";


//////////////////
// WEBPACK FOOTER
// /app/src/fonts/brand-icons/brand-icons.eot
// module id = ../../../../../src/fonts/brand-icons/brand-icons.eot
// module chunks = 5